import { ReportSettingState } from '..';
import { ClientCustomCalendarModel, ReportType } from '../../../../models';
import { validateReportSettingPITStateCommitment } from './validateReportSettingPITStateCommitment';
import { validateReportSettingPITStateMaturity } from './validateReportSettingPITStateMaturity';
import { validateReportSettingPITStateWeightedAverage } from './validateReportSettingPITStateWeightedAverage';

export interface PITValidationData {
  pitAsOfDate: Date;
  reportSettingState: ReportSettingState;
  customCalendarSettings: ClientCustomCalendarModel;
  localePreference: string;
}

const VALIDATORS = {
  [ReportType.weightedAverage]: validateReportSettingPITStateWeightedAverage,
  [ReportType.maturity]: validateReportSettingPITStateMaturity,
  [ReportType.committment]: validateReportSettingPITStateCommitment,
  [ReportType.leaseCommittment]: validateReportSettingPITStateCommitment,
  // TODO: add more validator for other report type
};

export const validateReportSettingPITStateForReportType = (
  validationData: PITValidationData,
  reportType: ReportType,
): string[] => {
  const validator = VALIDATORS[reportType];
  if (!validator) return [];
  return validator(validationData);
};
